import { HabitSchedule } from '@griply/types';
import {
  getTimeframeCompletions,
  GetTimeframeCompletionsOptions,
} from '@griply/utils';
import { useMemo } from 'react';

export type Options = GetTimeframeCompletionsOptions;

export const useTimeframeCompletions = (
  schedules: HabitSchedule[],
  { startDate, endDate }: Options,
) =>
  useMemo(
    () => getTimeframeCompletions(schedules, { startDate, endDate }),
    [endDate, schedules, startDate],
  );
